<template>
  <span class="element-input p-float-label" :class="getIconPos">
    <PIcon :icon="icon" />
    <InputText
      :id="name"
      :class="[{ 'p-invalid': !!msg }, bindingClass]"
      :type="type"
      :value="value"
      v-model="input"
      :disabled="disabled"
      @input="handleInput($event.target.value)"
      @blur="handleBlur()"
      @focus="handleForcus()"
    />
    <label :class="{ 'label-input': iconPos === 'left' }" :for="name">
      {{ label }}
    </label>
  </span>
  <small :class="{ 'p-invalid': !!msg }">{{ msg }}</small>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import { Options } from "vue-class-component";
import BaseElement from "../BaseElement.vue";

@Options({
  emits: ["focus", "blur", "change"]
})
export default class IziInput extends BaseElement {
  input = ref(this.value);
  public bindingClass = computed(() => this.class);

  getIconPos = computed(() =>
    !this.iconPos ? "" : `p-input-icon-${this.iconPos}`
  );

  handleInput(value: any) {
    this.$emit("update:value", value);
  }

  handleBlur() {
    this.$emit("blur");
  }

  handleForcus() {
    this.$emit("focus");
    this.$emit("update:msg", "");
  }
}
</script>

<style lang="scss" scoped>
.label-input {
  margin-left: 30px;
}
.p-inputtext {
  width: 100%;
  border-radius: 24px;
}
.p-inputtext:hover {
  border: 1px solid $border-input;
}
.p-inputtext:enabled:focus {
  box-shadow: inset 0 0 0 0 $border-input;
  border-color: $border-input;
}
.p-inputtext {
  color: $primary-color;
  font-weight: bold;
}
.p-float-label label {
  font-weight: bold;
  color: $primary-input;
}
.p-float-label input:focus ~ label,
.p-float-label .p-inputwrapper-focus ~ label {
  color: $border-input;
}

small {
  color: $Red;
}
.p-invalid {
  border-color: $Red;
}
</style>
